import React from "react";
import ceraMagicImg from "../../assets/images/skinefit/imgs/Artboard 10.jpg";
import firstImg from "../../assets/images/skinefit/imgs/Artboard 14.jpg";
import secondImg from "../../assets/images/skinefit/imgs/Artboard 8.jpg";
import aquaBalanceImg from "../../assets/images/skinefit/imgs/Artboard 4.jpg";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./slick-custom.css";
import Content from "./Content";

const Products = () => {
  const settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: true,
    autoplaySpeed: 2000,
  };

  const slideData = [
    {
      image: ceraMagicImg,
      content:
        "This non-sticky light gel-type cream contains, Niacinamide, Adenosine and 10 Herbal extracts to help make the skin stay radiant, firm and prevents loss to skin moisture. It strengthens skin's natural moisture barrier, regulates sebum production, - moisturises your skin, - maintains the skin's elasticity and firmness",
      title: "Cera Magic",
      backgroundClass: "bg-[#eaf4f4]",
      btnColor: "bg-[#1b263b]",
    },
    {
      image: aquaBalanceImg,
      content:
        "A water drop cream with droplets burst out like a water bomb explodes, forming a moisturizing film to supply moisture and nutrients to tired skin, helping to keep the skin moist and fresh while sleeping. It retains long-lasting moisture to the skin, promotes healthier skin, boosts the skin's natural protective barrier, speeds up wond healing.",
      title: "Aqua Balance",
      backgroundClass: "bg-[#d8f3dc]",
      btnColor: "bg-[#2d6a4f]",
    },
    {
      image: firstImg,
      content:
        "Eternal Youth cream effectivity improves skin tone and skin elasticity while preserving skin moisturel. Diminishes fine lines and winkles, - Enhances collagen production, - Promotes a lifting effect, - Resurfaces the skin texture for a smoother, more even-toned look.",
      title: "Eternal Youth",
      backgroundClass: "bg-[#fcf6bd]",
      btnColor: "bg-yellow-500",
    },
    {
      image: secondImg,
      content:
        "Cica Rescue contains Centella Asiatica Leaf Water to help soothe sensitive skin and make healthier skin. It reduces inflammation in skin,  minimises breakouts, soothes irritated skin, upports skin healing.",
      title: "Cica Rescue",
      backgroundClass: "bg-red-100",
      btnColor: "bg-red-400",
    },
  ];
  return (
    <div className="w-screen  ">
      <Slider {...settings}>
        {slideData.map((x, i) => {
          return (
            <Content
              key={x}
              image={x.image}
              title={x.title}
              index={i}
              content={x.content}
              backgroundClass={x.backgroundClass}
              btnColor={x.btnColor}
            />
          );
        })}
      </Slider>
    </div>
  );
};

export default Products;
